import { Component, OnInit,NgModule } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';
import {Options} from 'select2';
import { ActivatedRoute } from '@angular/router';
import * as _moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepickerModule, MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter, MatDatepickerInputEvent } from '@angular/material';
import { ApiService } from 'src/app/service/api.service';
import { DatePipe } from '@angular/common';
import { numValidation, mobile, email } from 'src/app/service/customValidation';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  imports:[
    MatDatepickerModule,
    MatNativeDateModule
  ]
})
@Component({
  selector: 'app-old-student',
  templateUrl: './old-student.component.html',
  styleUrls: ['./old-student.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class OldStudentComponent implements OnInit {
  inputFormGroup:FormGroup;
  message:string='';
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  name='';
  maxValid=false;
  maxDate=new Date();
  paymentModeList:Array<Select2OptionData>;
  constructor(private _formBuilder: FormBuilder,private route:ActivatedRoute,private api:ApiService,private datePipe:DatePipe) { 
    this.inputFormGroup=this._formBuilder.group({
      id:[''],
      name:['',Validators.required],
      course_name:['',Validators.required],
      institute_name:['',Validators.required],
      institute_address:[''],
      course_duration:[''],
      course_scope:[''],
      dueDate:[''],
      years:['',[Validators.required,numValidation()]],
      months:['',[Validators.required,numValidation()]],
      course_fee:['',[Validators.required,numValidation()]]
    });
  }

  ngOnInit() {
  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[''] : 
        this.api.get("searchStudent?ustatus=0&search="+term).pipe(
          map((response)=>{if(response.status){
            return response.data.map((item,index)=>{
              return {name:item.registrationId,display:item.name+"("+item.registrationId+")",id:item.id,uname:item.name};
            })
          }})
          )
      ),
      tap(() => this.searching = false)
    )

    formatter = (x: {name: string}) => x.name;
    rFormatter=(x: {display: string}) => x.display;

    selectedUser(item){
      this.inputFormGroup.patchValue({id:item.item.id,name:item.item.uname});

    }

  saveForm(form)
  {
    this.returnData=[];
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.name='';
      form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
      this.api.post(form.value,'oldAdmission').subscribe(data=>{
        if(data.status)
        {
         /* this.api.get('totalDues').subscribe(rtotal=>{
              this.dataPass.passDataService({total:rtotal.total});
          },(error)=>{});*/
          this.message=data.message;
         // this.returnData=data.details;
         // this.returnData['name']=document.querySelector<HTMLInputElement>("#name").value;
         alert(this.message);
        }
        else
        {
          this.message=data.message;
          alert(this.message);
        }

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        document.querySelector<HTMLInputElement>("#name").value='';
      },(error)=>{});

    }
  }

  yearPlus()
  {
    let year=this.inputFormGroup.controls.years.value;
    if(year=='')
    {
      this.inputFormGroup.patchValue({years:1});
    }
    else if(year<10)
    {
      this.inputFormGroup.patchValue({years:year+1});
    }
    
  }
  yearMinus()
  {
    let no=this.inputFormGroup.controls.years.value;
    if(no=='')
    {
      this.inputFormGroup.patchValue({years:1});
    }
    else if(parseInt(no)>1)
    {
      this.inputFormGroup.patchValue({years:no-1});
    }
    
    
  }
  monthPlus()
  {
    let no=this.inputFormGroup.controls.months.value;
    if(no=='')
    {
      this.inputFormGroup.patchValue({months:1});
    }
    else if(no<11)
    {
      this.inputFormGroup.patchValue({months:no+1});
    }
   
  }
  monthMinus()
  {
    let no=this.inputFormGroup.controls.months.value;
    if(no=='' || no<1)
    {
      this.inputFormGroup.patchValue({months:0});
    }
    else if(no<=11)
    {
      this.inputFormGroup.patchValue({months:no-1});
    }
   
  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
    
    
  }

}
